module.exports = __webpack_public_path__ + "static/media/6.97276063.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/remoteSmartLinkIOT/img/6.png
// module id = 469
// module chunks = 0